"use strict";var o=require("styled-components").css`
    position: relative;

    .gallery {
        .carousel {
            .nav {
                display: none;

                @media (min-width: ${({theme:o})=>o.breakpoints.large}) {
                    display: flex;
                }
            }
        }

        .thumbnails {
            display: none;

            @media (min-width: ${({theme:o})=>o.breakpoints.large}) {
                display: grid;
            }
        }
    }

    .tour-button {
        box-shadow: rgb(0 0 0 / 25%) 0px 2px 8px;
        border-radius: 2px;
        padding: 9px 8px;
        position: absolute;
        display: flex;
        top: 19px;
        left: 20px;
        margin: 0;
        z-index: 10;
        border: none;
        background: ${({theme:o})=>o.colors.common.light};
        cursor: pointer;
    }

    .tour-button-label {
        margin: 2px 0px 0px 4px;
    }

    button.modal-button {
        position: absolute;
        bottom: 10px;
        right: 10px;
        padding: 10px 8px;
        border-radius: 2px;
        outline: none;
        background: ${({theme:o})=>o.colors.primary.light};
        color: ${({theme:o})=>o.colors.common.dark};
        display: flex;
        flex-direction: row;
        align-items: center;
        z-index: 10;

        svg {
            margin-right: 4px;
        }

        &::after {
            display: block;
            content: '';
            position: absolute;
            top: -1px;
            left: -1px;
            width: 100%;
            height: 100%;
            border: 1px solid rgb(255, 255, 255);
            border-radius: inherit;
            transition: all 0.4s ease-in-out 0s;
            z-index: -1;
            background: rgb(255, 255, 255);
            opacity: 1;
        }

        @media (min-width: ${({theme:o})=>o.breakpoints.large}) {
            display: none;
        }
    }
`;module.exports=o;
//# sourceMappingURL=styles.js.map
